import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarAction,
  MatSnackBarActions,
  MatSnackBarLabel,
  MatSnackBarRef,
} from '@angular/material/snack-bar';
import { ApiError } from '../../api/api-error';
import { ApiErrorCode } from '../../api/api-error-code';

@Component({
  selector: 'jp-api-error-snack-bar',
  imports: [MatButton, MatSnackBarLabel, MatSnackBarActions, MatSnackBarAction],
  templateUrl: './api-error-snack-bar.html',
  styleUrl: './api-error-snack-bar.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApiErrorSnackBar {
  protected readonly snackBarRef = inject(MatSnackBarRef);
  protected readonly error = inject<ApiError>(MAT_SNACK_BAR_DATA);

  protected readonly codes = ApiErrorCode;

  protected dismiss(): void {
    this.snackBarRef.dismissWithAction();
  }
}
